import { HttpTypes } from '@medusajs/types'
import React from 'react'
import { cn } from '@/utilities/ui'

type OptionSelectProps = {
  option: HttpTypes.StoreProductOption
  current: string | undefined
  updateOption: (value: string) => void
}

const OptionSelect: React.FC<OptionSelectProps> = ({ option, current, updateOption }) => {
  return (
    <div className="mt-5">
      <p className="mb-2 text-sm font-semibold text-primary">
        {option.title}
        {current ? `: ${current}` : ''}
      </p>
      <div className="flex flex-wrap gap-2">
        {option.values?.map((value) => {
          const isSelected = current === value.value
          return (
            <button
              key={value.id}
              type="button"
              onClick={() => updateOption(value.value)}
              className={cn(
                'rounded-full border px-4 py-2 text-sm font-medium transition',
                isSelected
                  ? 'border-primary bg-primary text-white'
                  : 'border-border bg-background-light text-foreground hover:border-primary',
              )}
            >
              {value.value}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default OptionSelect
